<template>
  <v-layout fluid wrap>
    <v-flex xs12>
      <v-card>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <v-layout>
              <!-- <v-flex
                xs2
                md2
                class="text-lg-left"
              >
                <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="computed_dt_inicialFormatted"
                        label="Data Inicial"
                        hint="DD/MM/AAAA"
                        persistent-hint
                        prepend-icon="event"
                        locale="pt-br"
                        @blur="start_date = parseDate(dt_finalFormatted)"
                        v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker dark v-model="start_date" @input="menu1 = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex
                  xs2
                  md2
                  class="text-lg-left"
              >
                  <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                  >
                      <template v-slot:activator="{ on }">
                      <v-text-field
                          v-model="computed_dt_finalFormatted"
                          label="Data Final"
                          hint="DD/MM/AAAA"
                          persistent-hint
                          prepend-icon="event"
                          locale="pt-br"
                          @blur="end_date = parseDate(dt_finalFormatted)"
                          v-on="on"
                      ></v-text-field>
                      </template>
                      <v-date-picker dark v-model="end_date" @input="menu2 = false"></v-date-picker>
                  </v-menu>
              </v-flex> -->
              <v-flex xs12 md6>
                <v-text-field
                  v-model="urlCode"
                  :rules="urlCodeRules"
                  label="Código"
                  class="purple-input"
                  @keyup.enter="validate"
                />
              </v-flex>
              <v-flex xs12 md2>
                <v-btn
                  color="success"
                  @click="validate()"
                  :disabled="!valid || loading"
                  :loading="loading"
                  small
                >
                  <v-icon class="pr-1">search</v-icon>Buscar
                </v-btn>
              </v-flex>
              <v-flex xs12 md2>
                <v-btn
                  color="success"
                  dark
                  outline
                  @click="clear()"
                  :disabled="!valid || loading"
                  :loading="loading"
                  small
                >
                  <!-- <v-icon class="pr-1">search</v-icon> -->
                  Limpar
                </v-btn>
              </v-flex>
              <v-flex xs12 md2>
                <v-btn
                  color="success"
                  @click="openUrlShortnerForm('new')"
                  :disabled="loading"
                  small
                  outline
                  slot="center"
                >
                  <v-icon class="pr-1">receipt_long</v-icon>Adicionar
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
    </v-flex>
    <v-flex xs12>
      <v-card>
        <v-card-title> </v-card-title>

        <v-data-table
          :headers="headers"
          :items="urlShortners"
          :pagination.sync="pag"
          must-sort
        >
          <template v-slot:items="props">
            <td>{{ props.item.created_at | formatarDate }}</td>
            <td>{{ props.item.urlCode }}</td>
            <td>{{ props.item.shortUrl }}</td>
            <td>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <div class="text-truncate" style="max-width: 700px">
                      {{ props.item.longUrl }}
                    </div>
                  </div>
                </template>
                <span>{{ props.item.longUrl }}</span>
              </v-tooltip>
            </td>

            <td class="text-xs-right">
              <v-btn
                flat
                icon
                color="grey darken-1"
                @click="openUrlShortnerForm('edit', props.item)"
                :disabled="loading"
              >
                <v-icon>edit</v-icon>
              </v-btn>

              <!-- <v-tooltip bottom v-if="props.item.status !== 'disabled'">
                <template v-slot:activator="{ on }">
                  <v-btn flat icon color="grey darken-1" :disabled="loading" v-on="on">
                    <v-icon left @click.stop="startUpdate(props.item.id, props.item.status)" color="error"> cancel </v-icon>
                  </v-btn>
                </template>
                <span>Desativar Plano</span>
              </v-tooltip> -->

              <!-- <v-tooltip bottom v-else>
                <template v-slot:activator="{ on }">
                  <v-btn flat icon color="grey darken-1" :disabled="loading" v-on="on">                
                    <v-icon left @click.stop="startUpdate(props.item.id, props.item.status)" color="success">
                      task
                    </v-icon>
                  </v-btn>
                </template>      
              <span>Reativar Plano</span>       
              </v-tooltip> -->
            </td>
          </template>
        </v-data-table>

        <!-- <v-dialog v-model="dialog_modify_status_plan" max-width="290" dark>
          <v-card color="grey">
            <v-card-title class="headline">Tem certeza que deseja {{newPlanStatus !== 'disabled' ? 'ativar' : 'desativar'}} esse plano?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" right @click="dialog_modify_status_plan = false" dark > Não </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="green" right dark @click="restoreOrDelete()" > Sim </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
        <url-shortner-form />
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { eventBus } from "@/main";
import UrlShortnerForm from "./UrlShortnerForm.vue";
import moment from "moment";

export default {
  components: { UrlShortnerForm },
  data() {
    return {
      valid: false,
      urlCode: null,
      headers: [
        {
          text: "Criado em",
          align: "left",
          sortable: true,

          value: "created_at",
        },
        {
          text: "Código",
          value: "urlCode",
        },
        {
          text: "Url Curta",
          value: "shortUrl",
        },
        {
          text: "Url Longa",
          value: "longUrl",
        },
      ],
      pag: {
        rowsPerPage: 100,
      },
      end_date: moment().toDate(),
      start_date: moment().subtract(7, "days").toDate(),
      dt_inicial: new Date().toISOString().substr(0, 10),
      dt_inicialFormatted: this.formatDate(
        new Date().toISOString().substr(0, 10),
      ),
      dt_final: new Date().toISOString().substr(0, 10),
      dt_finalFormatted: this.formatDate(
        new Date().toISOString().substr(0, 10),
      ),
      menu1: false,
      menu2: false,
    };
  },
  computed: {
    ...mapState("configuration", ["loading", "urlShortners"]),
    computed_dt_inicialFormatted() {
      return this.formatDate(this.start_date);
    },
    computed_dt_finalFormatted() {
      return this.formatDate(this.end_date);
    },
  },
  mounted() {
    this.getUrlShortners({
      start_date: this.start_date,
      end_date: this.end_date,
    });
  },
  watch: {
    start_date() {
      this.dt_inicialFormatted = this.formatDate(this.start_date);
      let new_finalDate = new Date(this.start_date);
      let new_date = new_finalDate.setDate(new_finalDate.getDate() + 30);
      this.dt_final = new Date(new_date).toISOString().substr(0, 10);
    },
    end_date() {
      this.dt_finalFormatted = this.formatDate(this.end_date);
    },
  },
  methods: {
    ...mapActions("configuration", ["getUrlShortners"]),

    openUrlShortnerForm(type, data) {
      let obj = {
        status: true,
        type: type,
        data: data,
      };
      eventBus.$emit("UrlShortnerForm", obj);
    },

    async validate() {
      if (this.$refs.form.validate()) {
        this.valid = true;
        this.getUrlShortners({
          start_date: this.start_date,
          end_date: this.end_date,
          urlCode: this.urlCode,
        });
      }
    },
    clear() {
      this.urlCode = null;
      (this.end_date = moment().toDate()),
        (this.start_date = moment().subtract(7, "days").toDate()),
        this.getUrlShortners({
          start_date: this.start_date,
          end_date: this.end_date,
        });
    },
    formatDate(date) {
      if (!date) return null;
      if (typeof date === "object") date = date.toISOString().substr(0, 10);
      // console.log('d: ', date)
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      // console.log('dparse: ', date)
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
};
</script>
